<template>
  <div
    class="popover-menu-section"
    :class="[{ 'popover-menu-section--divider': divider, 'popover-menu-section--divider-bottom': dividerBottom }]"
  >
    <div v-if="title" class="popover-menu-section__title" v-html="title" data-test-id="popover-menu-section-title" />

    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PopoverMenuSection',

  props: {
    title: {
      type: String,
      default: '',
    },

    divider: {
      type: Boolean,
      default: false,
    },

    dividerBottom: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'placeholders/label';

.popover-menu-section {
  padding: 8px;
  position: relative;

  // if the section has no content, don't add padding
  &:empty {
    padding: 0;
  }
}

.popover-menu-section__title {
  @extend %generic-label;

  padding: 0 0 0 8px;
  min-height: 26px;
  display: flex;
  align-items: center;
}

.popover-menu-section--divider {
  border-top: 1px solid colors.$color-grey-200;
}

.popover-menu-section--divider-bottom {
  border-bottom: 1px solid colors.$color-grey-200;
}
</style>
